<template>
    <div class="col-12 graph-wrapper my-4">
        <div class="col-12 px-2 px-lg-0 mb-3 mb-lg-0 col-lg-5 graph-container">
            <!--<div id="winners-from-barrier-chart" class="chart"></div>-->
            <dx-chart id="winners-from-barrier-chart" :data-source="winnersFromBarrierData" title="% Winners from Barrier Draw" class="chart" >
                <dx-title text="% Winners from Barrier Draw" ><dx-font family="Raleway" size="16"/></dx-title>   
                <dx-series type="bar" color="#b81a10" argument-field="horsepos" />
                <dx-value-axis :show-zero="false" title="Percent"/>
           
                <dx-argument-axis title="Barrier Draw" >
                   
                    </dx-argument-axis>

                <dx-legend :visible="false"/>
            </dx-chart>
        </div>
        <div class="col-12 px-2 px-lg-0 mb-3 mb-lg-0 col-lg-5 graph-container">
            <!--<div id="places-from-barrier-chart" class="chart"></div>-->
            <dx-chart id="places-from-barrier-chart" :data-source="placesFromBarrierData" class="chart">
                <dx-title text="% Places from Barrier Draw" ><dx-font family="Raleway" size="16"/></dx-title>
                <dx-series type="bar" color="#0a21b8" argument-field="horsepos" />
                <dx-value-axis :show-zero="false" title="Percent" />
                <dx-argument-axis title="Barrier Draw" />
                <dx-legend :visible="false"/>
            </dx-chart>
        </div>
    </div>
</template>

<script>
    import { DxChart, DxSeries, DxValueAxis,DxArgumentAxis, DxLegend, DxTitle, DxFont, DxLabel } from 'devextreme-vue/chart';

    export default {
        name: 'RaceCardBarrierDraw',
        components: {
            DxChart,
            DxSeries,
            DxValueAxis,
            DxArgumentAxis,
            DxLegend,
            DxTitle,
            DxFont,
             DxLabel
        },
        data: function () {
            return {
                winnersFromBarrierData: {},
                placesFromBarrierData: {},
                
            };
        },
        props: {
            barrierDraw: Object
        },
        methods: {
            getImage(imagePath, fileType = 'svg') {
                return require('../assets/images/' + imagePath + '.' + fileType);
            }
        },
        mounted: function () {
            this.winnersFromBarrierData = this.barrierDraw.percWinners.map((percWinner, index) => {
                return { arg: index + 1, val: parseInt(percWinner)  , horsepos: (index+1).toString()};
            
            });

            this.placesFromBarrierData = this.barrierDraw.percPlaces.map((percPlace, index) => {
                return { arg: index + 1, val: parseInt(percPlace) , horsepos: (index+1).toString()};
            });

            document.getElementById('winners-from-barrier-chart')
        }
    }
</script>

<style scoped>
    .chart {
        display: flex;
        justify-content: center;
    }

    text {
        text-anchor: start !important;
    }

    @media (min-width: 992px) {
        .graph-wrapper {
            display: flex;
            justify-content: space-evenly;
        }

        .graph-container {
            display: inline-block;
        }
    }
</style>
